<template>
  <div class="schedule-main-wrapper">
    <v-container grid-list-lg id="schedule-toggle-filters" class="schedule-task-wrapper toggleOn-filters">
      <v-row class="fill-height">
        <v-col xs="12" sm="12" md="2" lg="2" class="schedule-col2-wrapper" @scroll ="onScroll">
          <div style="text-align:center">
            <p style="marginBottom:0px; font-weight:bold;">Unscheduled <span style="color: #b1b0b0; font-weight: 500;">{{ unscheduledTaskPagination.count }}</span></p>
          </div>
          <v-layout class="task-list">
           <v-flex xs12>
          <v-card class="sort-bar">
            <v-layout row wrap>
              <v-flex xs12 class="text-right pr-1" style="display: flex;">
                <div style="flex-grow: 1; float: left;">
                <v-select
                  :items="sortList"
                  solo
                  flat
                  outlined
                  v-model="selectedSortCode"
                ></v-select>
                </div>
                <div class="sort-direction-wrapper">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click='toggleSortDirection'
                      class="text-right"
                      color="accent"
                      small
                      icon
                      v-on="on"
                      height="24"
                      width="24"
                    >
                      <span v-if="isDesc"><v-icon>mdi-sort-descending</v-icon></span>
                      <span v-else><v-icon>mdi-sort-ascending</v-icon></span>
                    </v-btn>
                  </template>
                  <span>Sort Direction</span>
                </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        </v-layout>
          <v-layout row wrap class="schedule-task-list">
            <v-flex
              v-for="(item, i) in unscheduledTasks"
              :key="i"
            >
              <v-card
                @click="showItem(item)">
                <list-admin
                  :event="item">
                </list-admin>
              </v-card>
            </v-flex>
          </v-layout>
        </v-col>

        <v-col xs="12" sm="12" md="10" lg="10" cols="12" class="schedule-col1-wrapper">
          <v-sheet height="64" justify-center>
            <v-toolbar flat color="white">
              <v-btn
                outlined class="mr-4"
                @click="setToday"
                color="#feb264">
                Today
              </v-btn>
              <v-btn fab text small @click="prev">
                <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn fab text small @click="next">
                <v-icon small>mdi-chevron-right</v-icon>
              </v-btn>
              <v-toolbar-title style="font-weight:bold;">{{ title }}</v-toolbar-title>
              <div class="flex-grow-1"></div>
              <v-menu bottom right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="#feb264"
                    outlined
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon color="#feb264" right>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet class="calendar-wrapper">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              :events="eventsMapped"
              :event-height="20"
              :event-color="getEventColor"
              :event-margin-bottom="3"
              :now="today"
              :type="type"
              :showMonthOnFirst="false"
              @click:event="openEditTask"
              @click:more="viewDay"
              @click:date="viewDay"
              @change="updateRange"
            ></v-calendar>
            <edit-task
              :type="this.type"
              :showDialog="this.selectedOpen"
              :toggle="toggleEdit"
              :selectedElement="this.selectedElement"
            >
            </edit-task>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EditTask from '@/components/scheduling/Edit'
import ListAdmin from '@/components/scheduling/ListAdminTasks'

export default {
  components: {
    EditTask,
    ListAdmin
  },
  props: {
    calendarType: String
  },
  watch: {
    searchObject: {
      handler() {
        this.loadUnscheduled(this.searchUnscheduleObject(1, 25))
        this.loadScheduled(this.searchScheduleObject())
      },
      deep: true
    },
    userRole: {
      handler() {
        if (this.userRole === 'Sub Foreman') { // On log in, the page is loading with sub foreman as null
          this.loadUnscheduled(this.searchUnscheduleObject(1, 25))
          this.loadScheduled(this.searchScheduleObject())
        }
      },
      deep: true
    }
  },
  async created () {
    if(this.calendarType != null)
      this.type = this.calendarType
    this.setDate()
    this.isdAndRegion = this.isdAndRegion.concat()
    await this.loadUnscheduled(this.searchUnscheduleObject(1, 25))
    await this.loadScheduled(this.searchScheduleObject())
  },
  mounted () {
    this.$refs.calendar.checkChange()

    this.getCrews()
    let width = window.innerWidth
    if (width < 959) {
      let toggleScheduleFilters = document.getElementById('schedule-toggle-filters')
      if (!toggleScheduleFilters.classList.contains('toggleOff-filters')) {
        this.toggleFilters()
      }
    }
  },
  data: () => ({
    sortList: [
      { text: 'ISD', value: 'isd' },
      { text: 'WO#', value: 'work_order_number' }
    ],
    sortOrder: 'isd',
    isDesc: true,
    lastChanged: null,
    today: '2019-01-01',
    focus: '2019-01-01',
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days'
    },
    start: null,
    end: null,
    isdAndRegion: [],
    selectedEvent: {},
    selectedOpen: false,
    selectedElement: null,
    workOrderTask: {}
  }),
  computed: {
    ...mapGetters({
      events: 'workOrderTask/events', // scheduled tasks
      unscheduledTasks: 'workOrderTask/unscheduledTasks',
      searchObject: 'workOrderTask/searchObject',
      unscheduledTaskPagination: 'workOrderTask/unscheduledTaskPagination',
      userRole: 'user/role',
      userId: 'user/id'
    }),
    title () {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }
      const startMonth = this.monthFormatter(start)
      const endMonth = this.monthFormatter(end)
      const suffixMonth = startMonth === endMonth ? '' : endMonth
      const startYear = start.year
      const endYear = end.year
      const suffixYear = startYear === endYear ? '' : endYear
      const startDay = start.day + this.nth(start.day)
      const endDay = end.day + this.nth(end.day)
      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`
      }
      return ''
    },
    monthFormatter () {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long'
      })
    },
    selectedSortCode: {
      get () {
        return this.sortOrder
      },
      set (value) {
        this.sortOrder = value
        this.loadUnscheduled(this.searchUnscheduleObject(1, 25))
      }
    },
    eventsMapped: {
      get() {
        if (this.type === 'week') {
          return this.events.map(event => {
            event.start = event.start.slice(0, 10)
            event.end = event.end.slice(0, 10)
            return event
          })
        } else {
          return this.events
        }
      }
    }
  },
  methods: {
    ...mapActions({
      loadUnscheduled: 'workOrderTask/loadUnscheduledTasks',
      loadScheduled: 'workOrderTask/loadScheduledTasks',
      getTask: 'workOrderTask/getTask',
      toggleDirection: 'workOrderTask/toggleSortDirection',
      sortTasks: 'workOrderTask/sortTasks',
      getCrews: 'crew/loadCrews',
      loadScheduleDaysForTask: 'schedule/loadSchedule'
    }),
    async toggleSortDirection () {
      if (this.isDesc) { this.isDesc = false } else { this.isDesc = true }
      this.loadUnscheduled(this.searchUnscheduleObject(1, 25))
    },

    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },

    toggleEdit() {
      this.selectedOpen = !(this.selectedOpen)
      this.loadScheduled(this.searchScheduleObject())
      this.loadUnscheduled(this.searchUnscheduleObject(1, 25))
    },
    setDate () {
      let currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '-')
      this.today = currentDateWithFormat
      this.focus = currentDateWithFormat
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = this.today
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    openEditTask({ event }) {
      this.selectedEvent = event
      this.getTask(event.id)
      this.loadScheduleDaysForTask(event.id)
      this.selectedOpen = true
    },
    async showItem(item) {
      this.selectedEvent = item
      await this.getTask(this.selectedEvent.id)
      await this.loadScheduleDaysForTask(this.selectedEvent.id)
      this.selectedEvent.isd = item.isd.slice(0, 10)
      this.selectedEvent.name = `${this.selectedEvent.workOrder.workOrderNumber}-${this.selectedEvent.taskNumber}`

      this.selectedOpen = true
    },
    updateRange ({ start, end }) {
      this.start = start
      this.end = end
      this.loadScheduled(this.searchScheduleObject())
    },
    nth (d) {
      return d > 3 && d < 21
        ? 'th'
        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    },
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight) {
        if ((this.unscheduledTaskPagination.pageIndex * this.unscheduledTaskPagination.pageSize) < this.unscheduledTaskPagination.count) {
          let newPage = this.unscheduledTaskPagination.pageIndex + 1
          this.loadUnscheduled(this.searchUnscheduleObject(newPage, 25))
        }
      }
    },
    searchUnscheduleObject (pageIndex, pageSize) {
      // setting page index/size
      let searchReturn = { pageIndex: pageIndex, pageSize: pageSize }

      let search = { // tried to simplify but got other errors, infinite loop issue
        searchISD: this.searchObject.searchISD,
        searchRegion: this.searchObject.searchRegion,
        searchStatus: this.searchObject.searchStatus,
        searchGeneral: this.searchObject.searchGeneral,
        // searchCrew: this.searchObject.searchCrew,
        searchFlagged: this.searchObject.searchFlagged,
        searchLabel: this.searchObject.searchLabel,
        searchCheckedType: this.searchObject.searchCheckedType,
        searchWorkOrders: this.searchObject.searchWorkOrders,
        searchStartDate: this.searchObject.searchStartDate,
        searchCPA: this.searchObject.searchCPA,
        searchFCMP: this.searchObject.searchFCMP,
        searchDCMP: this.searchObject.searchDCMP,
        sortOrder: this.sortOrder,
        isDesc: this.isDesc,
        searchSubForeman: this.subForeman(),
        searchReturn: searchReturn
      }
      return search
    },
    searchScheduleObject () {
      const { start, end } = this
      let searchReturn = { }

      if (start !== null && end !== null) {
        searchReturn = {
        startPoint: start.date,
        endPoint: end.date
      }
      } else {
        let date = new Date()
        searchReturn= {
            startPoint: new Date(date.getFullYear(), date.getMonth(), 1),
            endPoint: new Date(date.getFullYear(), date.getMonth() + 1)
          }
      }


      let search = {
        searchISD: this.searchObject.searchISD,
        searchRegion: this.searchObject.searchRegion,
        searchStatus: this.searchObject.searchStatus,
        searchGeneral: this.searchObject.searchGeneral,
        searchCrew: this.searchObject.searchCrew,
        searchFlagged: this.searchObject.searchFlagged,
        searchLabel: this.searchObject.searchLabel,
        searchCheckedType: this.searchObject.searchCheckedType,
        searchWorkOrders: this.searchObject.searchWorkOrders,
        searchStartDate: this.searchObject.searchStartDate,
        searchCPA: this.searchObject.searchCPA,
        searchFCMP: this.searchObject.searchFCMP,
        searchDCMP: this.searchObject.searchDCMP,
        searchSubForeman: this.subForeman(),
        searchReturn: searchReturn
      }
      return search
    },
    subForeman() {
      if (this.userRole === 'Sub Foreman') {
        return this.userId
      } else if(this.userRole === null && this.searchObject.searchSubForeman !== null) {
        return this.searchObject.searchSubForeman
      } else {
        return null
      }
    },
    toggleFilters () {
      this.toggleFilterClasses()
      this.filterPanel = this.filterPanel !== 0 ? 0 : []
    },
    toggleFilterClasses () {

      let toggleScheduleFilters = document.getElementById('schedule-toggle-filters')
      if (toggleScheduleFilters) {
        toggleScheduleFilters.classList.toggle('toggleOff-filters')
      }
    }
  }
}
</script>
<style>
  .schedule-main-wrapper {
    position: fixed;
    overflow: hidden;
    height: 100%;
    left: 256px;
    right: 0;
  }
  .task-list .sort-bar {
    padding: 6px 2px 7px 10px;
  }
  .task-list {
    height: auto!important;
  }

  .task-list .sort-bar .v-input {
    font-size: 12px !important;
  }

  .task-list .sort-bar .v-text-field {
    padding: 0 !important;
    margin: 0 !important;
    height: 28px;
  }

  .task-list .sort-bar .v-text-field--outlined .v-input__control .v-input__slot {
    min-height: 32px;
  }

  .schedule-task-wrapper {
    max-width: 100% !important;
    min-width: 100% !important;
    padding: 0 0 0 12px;
  }

  .toggleOn-filters {
    height: calc(100% - 183px);
  }

  .toggleOff-filters {
    height: calc(100% - 71px) !important;
  }

  .schedule-col1-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding: 16px 28px 80px 0;
  }

  .calendar-wrapper {
    height: 100%;
    margin-top: 1px;
  }
  .schedule-col1-wrapper .v-btn--round .v-btn__content .v-icon {
    color: #f0a73a;
  }

  .schedule-col1-wrapper .v-btn--fab.v-size--small .v-icon {
    font-size: 26px !important;
  }

  .schedule-col1-wrapper .v-toolbar__title {
    padding-left: 16px;
  }

  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside,
  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
    padding-top: 10px;
  }

  .schedule-col2-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding: 10px 16px 0 16px;
  }

  .schedule-task-list {
    padding-bottom: 8px;
  }

  @media only screen and (max-width: 1263px) {
    .schedule-main-wrapper {
      left: 0;
    }
    .toggleOn-filters {
      height: calc(100% - 247px);
    }
    .toggleOff-filters {
      height: calc(100% - 135px) !important;
    }
  }
  @media only screen and (max-width: 959px) {
    .toggleOn-filters {
      height: calc(100% - 240px);
    }
    .toggleOff-filters {
      height: calc(100% - 129px) !important;
    }
    .schedule-task-wrapper {
      padding: 0 28px 0 28px;
    }
    .schedule-col1-wrapper {
      padding-right: 0;
    }
    .schedule-col2-wrapper {
      display: none;
    }
  }
  @media only screen and (max-width: 800px) {
    .toggleOn-filters {
      height: calc(100% - 408px);
    }
    .toggleOff-filters {
      height: calc(100% - 129px) !important;
    }
  }
  @media only screen and (max-width: 540px) {
    .toggleOn-filters {
      height: calc(100% - 449px);
    }
    .toggleOff-filters {
      height: calc(100% - 168px) !important;
    }
  }
</style>
